import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { ScenePreview } from '../../types/avatarFlow';
import styles from './HdScenePicker.module.css';

export interface HdScenePickerProps {
  scenes: ScenePreview[];
  onPick: (scene: ScenePreview) => void;
  testId?: string;
}

export function HdScenePicker({
  scenes,
  onPick,
  testId = 'hd-scene-picker',
}: HdScenePickerProps): JSX.Element {
  const { t } = useTranslation('flows');
  const [selectedId, setSelectedId] = useState<string | null>(null);

  return (
    <div className={styles.root} data-testid={testId}>
      <h2 className={styles.title}>{t('avatarFlow.hd.pickScene.title')}</h2>
      <p className={styles.subtitle}>{t('avatarFlow.hd.pickScene.subtitle')}</p>
      <div className={styles.grid} role="list">
        {scenes.slice(0, 6).map((scene) => {
          const isSelected = scene.id === selectedId;
          return (
            <button
              key={scene.id}
              type="button"
              role="listitem"
              aria-pressed={isSelected}
              className={`${styles.cell} ${isSelected ? styles.cellSelected : ''}`}
              onClick={() => {
                setSelectedId(scene.id);
                onPick(scene);
              }}
              data-testid={`hd-scene-${scene.id}`}
            >
              <img src={scene.imageUrl} alt="" className={styles.thumb} />
              <div className={styles.label}>{t(scene.labelKey, { defaultValue: scene.id })}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
